import { render, staticRenderFns } from "./CoOtpVerification.vue?vue&type=template&id=7e11b60e&scoped=true&"
import script from "./CoOtpVerification.vue?vue&type=script&lang=ts&"
export * from "./CoOtpVerification.vue?vue&type=script&lang=ts&"
import style0 from "./CoOtpVerification.vue?vue&type=style&index=0&id=7e11b60e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e11b60e",
  null
  
)

export default component.exports